.item {
	display: grid;
	grid-template-columns: auto 1fr auto;
	align-items: center;
	gap: var(--space-3);
	padding: var(--space-3) var(--space-4);
	background: var(--surface-card);
	border: 1px solid var(--border);
	border-radius: var(--radius-md);
}

/* Right-hand cluster: assignees (family only), priority, category. Grouped in
   one grid column so the grid template stays stable across modes. */
.controls {
	display: flex;
	align-items: center;
	gap: var(--space-1);
}

.title {
	background: none;
	border: none;
	padding: 0;
	margin: 0;
	font: inherit;
	color: inherit;
	text-align: left;
	cursor: text;
	min-width: 0;
	overflow-wrap: anywhere;
}

/* Offline: the text stays at full strength, only the edit affordance goes. */
.title:disabled {
	cursor: default;
}

.editor {
	background: var(--surface-input);
	border: 1px solid var(--border);
	border-radius: var(--radius-sm);
	padding: 4px 8px;
	margin: -5px -9px;
	width: calc(100% + 18px);
	outline: none;
}

.editor:focus {
	border-color: var(--accent-sage);
}

.done .title {
	color: var(--ink-muted);
	text-decoration: line-through;
}

.tag,
.star,
.assign {
	border: none;
	background: transparent;
	min-width: 32px;
	height: 32px;
	padding: 0 var(--space-1);
	border-radius: var(--radius-sm);
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	justify-content: center;
}

.tag:hover:not(:disabled),
.star:hover:not(:disabled),
.assign:hover:not(:disabled) {
	background: var(--surface-input);
}

.tag:disabled,
.star:disabled,
.assign:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}
